import { gql, useLazyQuery, type LazyQueryHookOptions } from "@apollo/client";

const PROPERTY_LISTINGS_QUERY = gql`
  query PropertyListings($filter: PropertyListingFilters) {
    propertyListings(filter: $filter) {
      id
      slug
      addressLine1
      unitNumber
      city
      province
      postalCode
      lease
      leasePerUnit
      leasePerTime
      price
      bathroomTotal
      bedroomsTotal
      images {
        id
        url
      }
    }
  }
`;

interface PropertyListingsVariables {
  filter: {
    listingAgentKeys: string[];
  };
}

interface ListingImage {
  id: string;
  url: string | undefined;
}

interface PropertyListing {
  id: string;
  slug: string;
  addressLine1: string | null;
  unitNumber: string | null;
  city: string | null;
  province: string | null;
  postalCode: string | null;
  lease: string | null;
  leasePerUnit: string | null;
  leasePerTime: string | null;
  price: string | null;
  bathroomTotal: string | null;
  bedroomsTotal: string | null;
  images: ListingImage[];
}

interface PropertyListingsData {
  propertyListings: PropertyListing[];
}

const usePropertyListingsLazyQuery = (
  options?: LazyQueryHookOptions<PropertyListingsData, PropertyListingsVariables>,
) => {
  return useLazyQuery<PropertyListingsData, PropertyListingsVariables>(
    PROPERTY_LISTINGS_QUERY,
    options,
  );
};

export { usePropertyListingsLazyQuery };
export type { PropertyListingsData };
